import Vue from 'vue'
import Vuex from 'vuex'
import scorm from '@shared/utils/scormHandler'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stepIndex: 0,
    steps: ['intro', 'videoStep', 'gapFillHeures', 'outro'],
    gameFinished: false
  },
  getters: {
    currentStep (state) {
      return state.steps[state.stepIndex]
    },
    progress (state) {
      return state.stepIndex / (state.steps.length - 1) * 100
    },
    status (state, getters) {
      return getters.progress === 100 && state.gameFinished ? 'passed' : 'incomplete'
    }
  },
  mutations: {
    loadState (state, datas) {
      state.stepIndex = datas.stepIndex
      state.gameFinished = datas.gameFinished
    },
    nextStep (state) {
      state.stepIndex++
    },
    navigateTo (state, index) {
      state.stepIndex = index
    },
    setGameFinished (state, status) {
      state.gameFinished = status
    }
  },
  actions: {
    next ({ state, dispatch, commit }) {
      if (state.stepIndex === state.steps.length - 1) {
        dispatch('exit')
      } else {
        commit('nextStep')
      }
    },
    navigate ({ state, commit }, stepName) {
      commit('navigateTo', state.steps.indexOf(stepName))
    },
    init ({ dispatch }) {
      scorm.initLMSConnection()
      dispatch('load')
    },
    save ({ state, getters }) {
      scorm.setDatasToLMS({
        stepIndex: state.stepIndex,
        gameFinished: state.gameFinished
      })
      scorm.writeProgressToLMS(getters.progress, getters.status)
      try {
        scorm.commitToLMS()
      } catch (e) {
        if (process.env.NODE_ENV === 'production') {
          console.log('SCORM api error : ' + e)
        }
      }
    },
    load ({ commit }) {
      if (scorm.getDatasFromLMS()) {
        commit('loadState', scorm.getDatasFromLMS())
      }
    },
    exit ({ dispatch }) {
      dispatch('save')
      scorm.exitLMSConnection()
    }
  }
})
